/** @module SiteAdmin/CentricDrive/ShareWithMeController */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/locale",
	"csi/action/Controller",
	"csi/comm/PostRequest",
	"csi/xml",
	"csi/widget/MessageDialog"

	], function(declare,lang,locale,Controller,PostRequest,xml,MessageDialog) {

	return declare(Controller, {

		/**
		 * @Override
		 * Display DialogMessage to inform document was successfully shared
		 */
		onPublishResponse: function(response) {
			const node = response.getResultNode();
			this.displayShareFileLocationMsg(node.IsAlreadyShared ? "DriveFileAlreadyDownloaded" : "DriveFileDownload", node.FilePath);
		},
		/**
		 * @Override
		 * Display Dialog Message to inform where to find the document file
		 * @param msgResource Message Resource key
		 * @param localPath
		 */
		displayShareFileLocationMsg: function(msgResource, localPath){
			new MessageDialog({
				buttons: [MessageDialog.BUTTON_OK],
				materialIcon: MessageDialog.ICON_INFO,
				message: locale.resource(msgResource, [localPath]),
				title: locale.resource("INFORMATION")
			}).show();
		},
		/**
		 * @Override
		 * Process PostRequest for sharing a document with the current User.
		 */
		process: function() {
			var req = this.m_action.m_request;
			var fd = this.m_formData;
			var writeAccess = xml.nodeHasRight(this.getNode(), xml.RIGHT_WRITE);
			this.setProgress();
			var postRequest = new PostRequest("DocumentProcessing", "ManageDriveDownload");
			postRequest.addParameter("URL", this.getNode().$URL);
			postRequest.addParameter("DocumentRevisionCNLId", this.getNode().$URL);
			postRequest.addParameter("WriteAccess", !!writeAccess);
			this.waitForPublish(postRequest.post({}) , true);
		}
	});
});
